<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="full-height" style="padding: 20px; padding-bottom: 0; height: 100%">
    <el-tabs v-model="panel" @tab-click="handleClick">
      <el-tab-pane label="首頁輪播圖" name="images"> </el-tab-pane>
      <el-tab-pane label="hashtags集合" name="hashtags"> </el-tab-pane>
    </el-tabs>

    <div style="padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="success" @click="addData" :disabled="listLoading">建立</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="圖片" width="500">
          <template slot-scope="scope">
            <el-image
              style="height: 50px"
              :src="scope.row.fileInfo[0].files[0].url"
              fit="contain"
              :preview-src-list="fileUrl(scope.row.fileInfo)"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column v-if="panel !== 'hashtags'" align="center" label="網址" width="400">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'hashtags'" align="center" label="標題" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'hashtags'" align="center" label="HashTags" width="110">
          <template slot-scope="scope">
            <span>{{ changeShow(scope.row.hashTags) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column label="刪除" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleDelete(scope)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      @closed="onDialogClosed"
      :title="'編輯'"
      :visible.sync="dialogFormVisible"
      width="50%"
      top="1%"
      style="border: 2px solid #ccc"
    >
      <el-card class="box-card" v-loading="formLoading" :body-style="{ border: '1px solid #ccc' }">
        <el-row>
          <el-col>
            <el-form ref="dynamicValidateForm" :model="formData">
              <el-form-item label="圖片" :label-width="formLabelWidth">
                <div>
                  <Upload
                    ref="uploadRef"
                    :accept="'.jpg,.jpeg,.png'"
                    :payload="formData"
                    :data-obj="fileObj"
                    :limitText="
                      panel == 'images'
                        ? '請同時上傳電腦版及手機版圖片，尺寸:電腦版1440x200、手機版320x200，手機版檔名須加上_mobile，須為.jpg,.jpeg,.png格式，限制不超過2000MB'
                        : '圖片尺寸:100x100，須為.jpg,.jpeg,.png格式，限制不超過2000MB'
                    "
                    :limit-file-count="panel == 'images' ? 2 : 1"
                    :use-drag="false"
                    :action="'ToursCombine/saveIndexCarousel'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="formLoading"
                    :btn-txt="'上傳'"
                    :before-file-list="
                      formData.fileInfo && formData.fileInfo.length
                        ? formData.fileInfo[0].files
                        : []
                    "
                  />
                </div>
              </el-form-item>
              <el-form-item
                label="網址"
                :label-width="formLabelWidth"
                prop="content"
                :rules="[{ validator: validateLink, trigger: 'blur' }]"
              >
                <el-input v-model="formData.content" autocomplete="off" />
              </el-form-item>
              <el-form-item
                v-if="panel == 'hashtags'"
                label="標題"
                :label-width="formLabelWidth"
                prop="title"
                :rules="[
                  {
                    required: true,
                    message: '請輸入標題',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.title" autocomplete="off" />
              </el-form-item>
              <el-form-item
                v-if="panel == 'hashtags'"
                label="hashTags"
                :label-width="formLabelWidth"
                prop="hashTags"
              >
                <el-select
                  v-model="formData.hashTags"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="請輸入關鍵字"
                  :remote-method="remoteMethod"
                  :loading="loading"
                  :no-data-text="'無資料'"
                  value-key="id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.title"
                    :value="item"
                  >
                  </el-option>
                </el-select>

                <!-- <el-input v-model="formData.hashtags" autocomplete="off" /> -->
              </el-form-item>
              <el-form-item
                label="排序"
                :label-width="formLabelWidth"
                prop="sort"
                :rules="[
                  {
                    required: true,
                    message: '請輸入排序',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.sort" autocomplete="off" type="number" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('dynamicValidateForm')">儲 存</el-button>

        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import {
  getIndexCarousel,
  saveIndexCarousel,
  getHashTagSelectList,
  getHashTagGather,
  saveHashTagGather,
  deleteIndexCarousel,
  deleteHashTagGather,
} from '@/api/tcSetting'
var defaultFormData = {
  id: null,
  fileInfo: [],
  sort: null,
  title: 'carousel',
}

var defaultHashTagGatherFormData = {
  id: null,
  fileInfo: [],
  sort: null,
  title: '',
  hashtags: [],
}

export default {
  components: {
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
  },
  computed: {
    changeShow() {
      return function (array) {
        return array
          .map(item => {
            return item.title
          })
          .toString()
      }
    },
    fileUrl() {
      return function (array) {
        if (array.length) {
          var list = array[0].files.map(x => {
            return x.url
          })
          return list
        } else {
          return ['https://fakeimg.pl/1440x200/']
        }
      }
    },
  },
  data() {
    var validateLink = (rule, value, callback) => {
      if (value == '' || value == null) {
        callback()
      } else if (!value.includes('https://')) {
        callback(new Error('請貼上正確的連結'))
      } else {
        callback()
      }
    }
    return {
      fileObj: { id: 0, type: 'tourInfo', user: '' },
      formLoading: false,
      formData: {},
      panel: 'images',
      listLoading: false,
      list: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      loading: false,
      options: [],
      hashTagList: [],
      validateLink: validateLink,
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    async handleClick(tab, event) {
      this.list = []
      if (tab.name == 'images') {
        await this.getList()
      } else {
        await this.getHashTagSelectList()
        await this.getHashtags()
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.hashTagList.filter(item => {
            return item.title.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      await getIndexCarousel().then(response => {
        vm.list = response.data
        vm.listLoading = false
      })
    },
    async getHashtags() {
      const vm = this
      vm.listLoading = true
      await getHashTagGather().then(response => {
        vm.list = response.data
        vm.listLoading = false
      })
    },
    async getHashTagSelectList() {
      const vm = this
      vm.listLoading = true
      await getHashTagSelectList()
        .then(response => {
          vm.hashTagList = response.data.data
          vm.listLoading = false
        })
        .catch(error => {})
    },
    addData() {
      let vm = this
      if (vm.panel == 'images') {
        vm.formData = JSON.parse(JSON.stringify(defaultFormData))
      } else {
        vm.formData = JSON.parse(JSON.stringify(defaultHashTagGatherFormData))
      }
      vm.dialogFormVisible = true
    },
    editData(d) {
      console.log(d)
      const vm = this
      //為了要觸發Upload的watch beforeFileList
      vm.formData.fileInfo = []
      //複製物件
      let jData = JSON.parse(JSON.stringify(d))
      vm.formData = jData
      this.options = vm.formData.hashTags
      vm.dialogFormVisible = true
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['dynamicValidateForm'].clearValidate()
    },
    async saveData(formName) {
      console.log(this.formData)
      const vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      let refUpload = this.$refs['uploadRef']

      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          if (payload.fileInfo[0].files.length == 0 && payload.fileIDs.length == 0) {
            this.$message.error('請上傳圖片')
            return false
          }
          vm.formLoading = true
          if (this.panel == 'images') {
            await saveIndexCarousel(payload)
              .then(async response => {
                refUpload.clearFiles()
                vm.dialogFormVisible = false
                vm.formLoading = false
                await this.getList()
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            await saveHashTagGather(payload)
              .then(async response => {
                console.log(response)
                refUpload.clearFiles()
                vm.dialogFormVisible = false
                vm.formLoading = false
                await this.getHashtags()
              })
              .catch(error => {
                console.log(error)
              })
          }

          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleDelete({ $index, row }) {
      console.log($index, row)
      this.$confirm('確定刪除該筆資料?', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.loading = true
          if (this.panel == 'images') {
            await deleteIndexCarousel({ id: row.id })
            await this.getList()
          } else {
            await deleteHashTagGather({ id: row.id })
            await this.getHashtags()
          }

          this.loading = false

          this.$message({
            type: 'success',
            message: '刪除成功',
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
<style lang="scss" scoped>
.is-scrolling-none {
  height: 100% !important;
}
</style>
